import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
export function PageHeading(_ref) {
  let {
    title,
    subtitle
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    direction: "vertical",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    textAlign: "center"
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, subtitle));
}
//# sourceMappingURL=PageHeading.js.map